import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const statusOptions = [
  { key: 'active', text: 'Active', value: 1 },
  { key: 'inactive', text: 'Inactive', value: 0 }
];

const IsOptions = [
  { key: 'active', text: 'Yes', value: 1 },
  { key: 'inactive', text: 'No', value: 0 }
];

const CreateVariantForm = ({
  loading,
  cuisineTypesDD,
  formTypesDD,
  mealTypesDD,
  quantityTypesDD,
  taxTypesDD,
  productsDD,
  onChangeOfCuisineType,
  onChangeOfDescription,
  onChangeOfFormType,
  onChangeOfImagePath,
  onChangeOfIsActive,
  onChangeOfIsSpecial,
  onChangeOfIsVeg,
  onChangeOfMealType,
  onChangeOfMicrowaveHeating,
  onChangeOfName,
  onChangeOfPackageWeight,
  onChangeOfProduct,
  onChangeOfTitle,
  onChangeOfTaxTypeId,
  onChangeOfServing,
  onChangeOfShelfLife,
  onChangeOfQuantityValue,
  onChangeOfQuantityTypeId,
  submitLoading,
  handleSubmit
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Create New Variant</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Create New Variant
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row loading={loading} style={{ marginBottom: '8em' }}>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Name of Variant</label>
            <input placeholder="Example: Poha" onChange={onChangeOfName} />
          </Form.Field>
          <Form.Field required>
            <label>Title of Variant</label>
            <input placeholder="Example: Poha Spicy" onChange={onChangeOfTitle} />
          </Form.Field>
          <Form.Field required>
            <label>Description</label>
            <input placeholder="Example: Poha with salad" onChange={onChangeOfDescription} />
          </Form.Field>
          <Form.Field required>
            <label>Select Product</label>
            <Dropdown
              placeholder="Select Product"
              loading={loading}
              selection
              search
              options={productsDD}
              onChange={onChangeOfProduct}
            />
          </Form.Field>
          <Form.Field required>
            <label>Form Type</label>
            <Dropdown
              placeholder="Select Form Type"
              loading={loading}
              selection
              search
              options={formTypesDD}
              onChange={onChangeOfFormType}
            />
          </Form.Field>
          <Form.Field required>
            <label>Meal Type</label>
            <Dropdown
              placeholder="Select Meal Type"
              loading={loading}
              selection
              search
              options={mealTypesDD}
              onChange={onChangeOfMealType}
            />
          </Form.Field>
          <Form.Field required>
            <label>Cuisine Type</label>
            <Dropdown
              placeholder="Select Cuisine Type"
              loading={loading}
              selection
              search
              options={cuisineTypesDD}
              onChange={onChangeOfCuisineType}
            />
          </Form.Field>
          <Form.Field required>
            <label>Is Veg</label>
            <Dropdown
              placeholder="Select Yes / No"
              selection
              options={IsOptions}
              onChange={onChangeOfIsVeg}
            />
          </Form.Field>
          <Form.Field required>
            <label>Is Special</label>
            <Dropdown
              placeholder="Select Yes / No"
              selection
              options={IsOptions}
              onChange={onChangeOfIsSpecial}
            />
          </Form.Field>
          <Form.Field required>
            <label>Serving</label>
            <input
              placeholder="Example: 1 (only enter no. of serve)"
              onChange={onChangeOfServing}
            />
          </Form.Field>
          <Form.Field required>
            <label>Shelf Life</label>
            <input
              placeholder="Example: 45 (only enter no. of days)"
              onChange={onChangeOfShelfLife}
            />
          </Form.Field>
          <Form.Field required>
            <label>Quantity Type</label>
            <Dropdown
              placeholder="Select Quantity Type"
              loading={loading}
              selection
              options={quantityTypesDD}
              onChange={onChangeOfQuantityTypeId}
            />
          </Form.Field>
          <Form.Field required>
            <label>Quantity Value</label>
            <input placeholder="Example: 350 (for 350 units)" onChange={onChangeOfQuantityValue} />
          </Form.Field>
          <Form.Field required>
            <label>With Packaging Weight</label>
            <input
              placeholder="Example: 90 (only enter number value)"
              onChange={onChangeOfPackageWeight}
            />
          </Form.Field>
          <Form.Field required>
            <label>Microwave Heating</label>
            <input placeholder="Example: 3" onChange={onChangeOfMicrowaveHeating} />
          </Form.Field>
          <Form.Field required>
            <label>Image Path</label>
            <input placeholder="Example: poha.jpg" onChange={onChangeOfImagePath} />
          </Form.Field>
          <Form.Field required>
            <label>Tax Type</label>
            <Dropdown
              placeholder="Select GST Values"
              loading={loading}
              selection
              options={taxTypesDD}
              onChange={onChangeOfTaxTypeId}
            />
          </Form.Field>
          <Form.Field required>
            <label>Is Active</label>
            <Dropdown
              placeholder="Select Status"
              selection
              options={statusOptions}
              onChange={onChangeOfIsActive}
            />
          </Form.Field>
          <Form.Field />
          <Button
            basic
            color="blue"
            style={{ float: 'right' }}
            disabled={submitLoading}
            loading={submitLoading}
            onClick={handleSubmit}
          >
            Add Variant
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateVariantForm;



// WEBPACK FOOTER //
// ./src/Modules/CreateNewVariant/component.jsx